/** @format */

import OrdersCreateComplexTenderPage from './OrdersCreateComplexTenderPage';
export default OrdersCreateComplexTenderPage;
